import styled from "@emotion/styled";
import CheckIcon from "@assets/icons/check.svg";
import { colors as styleColors } from "@ui/style/colors";
import React, { useMemo } from "react";

type CheckmarkSize = "S" | "M" | "L";

const checkmarksizes: Record<CheckmarkSize, { circle: string; check: number }> = {
	S: { circle: "1.5rem", check: 15 },
	M: { circle: "2.5rem", check: 24 },
	L: { circle: "4.5rem", check: 45 },
};

interface CheckmarkIconProps {
	size?: CheckmarkSize;
	colors?: { circle?: string; check?: string };
	className?: string;
}

export const CheckmarkIcon: React.FC<CheckmarkIconProps> = ({
	size = "S",
	colors = { circle: styleColors.validation, check: styleColors.white },
	className,
}) => {
	const { circle, check } = useMemo(() => checkmarksizes[size], [size]);

	return (
		<Circle size={circle} backgroundColor={colors.circle} className={className}>
			<CheckIcon width={check} height={check} color={colors.check} />
		</Circle>
	);
};

const Circle = styled.div<{ size: string; backgroundColor?: string }>`
	display: grid;
	place-items: center;
	width: ${({ size }) => size};
	height: ${({ size }) => size};
	border-radius: 50%;
	${({ backgroundColor }) => backgroundColor && `background-color: ${backgroundColor};`}
`;
